(function () {
  'use strict';
  var jfLocale=(window.JuanaThemeI18n&&window.JuanaThemeI18n.locale)||'en';
  var jfIsPolish=jfLocale.toLowerCase().startsWith('pl')||jfLocale.toLowerCase().startsWith('pt')||jfLocale.toLowerCase().startsWith('nl')||jfLocale.toLowerCase().startsWith('sv');
  function tr(text){return (window.JuanaThemeI18n&&window.JuanaThemeI18n.texts&&window.JuanaThemeI18n.texts[text])||text;}

  if (window.JuanaSizeFinder) { window.JuanaSizeFinder.init(); return; }
  var ranks = {'2XS':0,'XXS':0,'XS':1,'S':2,'S/M':2.5,'M':3,'M/L':3.5,'L':4,'L/XL':4.5,'XL':5,'XXL':6,'2XL':6,'3XL':7,'XXXL':7,'4XL':8,'5XL':9,'6XL':10};
  function estimate(cm, kg, gender, small, sizes) {
    if (!Number.isFinite(cm) || !Number.isFinite(kg) || cm < 140 || cm > 210 || kg < 30 || kg > 200) return {error:tr('Enter a height between 4 ft 7 in and 6 ft 10 in (140-210 cm) and a weight between 66 and 441 lb (30-200 kg).')};
    if (gender !== 'female' && gender !== 'male') return {error:tr('Choose a sizing reference first.')};
    // Broad starting estimates, not a manufacturer size chart or validated fit model.
    var ref = gender === 'male' ? 175 : 165;
    var centers = gender === 'male' ? [56,63,71,80,91,103,116,130,146,163,181] : [43,48,55,63,72,83,95,108,122,138,155];
    var scaled = kg * Math.pow(ref / cm, 1.65);
    if (scaled < centers[0]-8 || scaled > centers[10]+12) return {error:tr('Your measurements fall outside this estimator’s range. Please compare garment measurements before ordering.')};
    var target = 0;
    centers.forEach(function (x,i) { if (Math.abs(x-scaled) < Math.abs(centers[target]-scaled)) target=i; });
    if (small) target += 1;
    var choices = sizes.filter(function (s) { return Object.prototype.hasOwnProperty.call(ranks,s); });
    if (!choices.length) return {error:tr('No size is currently available for this selection.')};
    choices.sort(function(a,b) { return Math.abs(ranks[a]-target)-Math.abs(ranks[b]-target) || ranks[b]-ranks[a]; });
    if (Math.abs(ranks[choices[0]]-target) > 0.75) return {error:tr('No currently available size is close enough to the estimate. Please check another color or compare garment measurements.')};
    return {size:choices[0]};
  }
  function show(el, visible, display) { el.hidden=!visible; el.style.display=visible?(display||'block'):'none'; }
  function num(el) { return el.value.trim()==='' ? NaN : Number(el.value.replace(',','.')); }
  function init() {
    document.querySelectorAll('.jf-size-finder[data-jf-config]').forEach(function (box) {
      if (box.dataset.jfReady) return;
      var cfg;
      try { cfg=JSON.parse(box.getAttribute('data-jf-config')); } catch (_) { return; }
      if (!cfg.handle || !Array.isArray(cfg.sizes)) return;
      box.dataset.jfReady='true';
      if(jfIsPolish){
        var walker=document.createTreeWalker(box,NodeFilter.SHOW_TEXT);
        var node;
        while((node=walker.nextNode())){
          if(node.parentElement.closest('style,script,[data-jf-result]'))continue;
          var trimmed=node.nodeValue.trim(),translated=tr(trimmed);
          if(trimmed&&translated!==trimmed)node.nodeValue=node.nodeValue.replace(trimmed,translated);
        }
      }
      var q=function(s){return box.querySelector(s);};
      var result=q('[data-jf-result]'), button=q('[data-jf-calculate]'), units=q('[data-jf-units]');
      show(q('[data-jf-fields]'),true); show(q('[data-jf-fallback]'),false);
      if (!cfg.gender) show(q('[data-jf-cut-label]'),true);
      if (cfg.colors && cfg.colors.length && cfg.color_index !== null) {
        cfg.colors.forEach(function(c){var o=document.createElement('option');o.value=c;o.textContent=jfIsPolish&&window.JuanaThemeI18n.colors[c]?window.JuanaThemeI18n.colors[c]:c;q('[data-jf-color]').appendChild(o);});
        show(q('[data-jf-color-label]'),true);
      }
      units.addEventListener('change',function(){
        show(q('[data-jf-us]'),units.value==='us','flex'); show(q('[data-jf-metric]'),units.value==='metric');result.textContent='';
      });
      if(jfIsPolish){units.value='metric';show(q('[data-jf-us]'),false);show(q('[data-jf-metric]'),true);}
      var generation=0;
      box.addEventListener('input',function(){generation+=1;result.textContent='';});
      box.addEventListener('change',function(){generation+=1;result.textContent='';});
      button.addEventListener('click',async function(){
        var ticket=++generation;
        var cm,kg;
        if(units.value==='metric'){cm=num(q('[data-jf-cm]'));kg=num(q('[data-jf-kg]'));}
        else {
          var ft=num(q('[data-jf-ft]')),inch=num(q('[data-jf-in]'));
          if(!Number.isInteger(ft)||!Number.isFinite(inch)||inch<0||inch>=12){result.textContent=tr('Enter feet and inches separately. Inches must be between 0 and 11.9.');return;}
          cm=(ft*12+inch)*2.54;kg=num(q('[data-jf-lb]'))*0.45359237;
        }
        var gender=cfg.gender||q('[data-jf-cut]').value;
        var early=estimate(cm,kg,gender,cfg.runs_small,cfg.sizes);
        if(early.error){result.textContent=early.error;return;}
        button.disabled=true;button.textContent=tr('Checking available sizes…');result.textContent='';
        var controller=new AbortController(),timeout=setTimeout(function(){controller.abort();},10000);
        try {
          var root=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
          var response=await fetch(root+'products/'+encodeURIComponent(cfg.handle)+'.js',{credentials:'same-origin',signal:controller.signal,cache:'no-store'});
          if(!response.ok)throw new Error('Product unavailable');
          var product=await response.json();
          if(!Array.isArray(product.variants))throw new Error('Variants unavailable');
          var desiredColor=q('[data-jf-color]').value;
          if(desiredColor&&cfg.color_index!==null&&!product.variants.some(function(v){return v.options[cfg.color_index]===desiredColor;})){
            var colorIndex=cfg.colors.indexOf(desiredColor);
            var productColors=Array.from(new Set(product.variants.map(function(v){return v.options[cfg.color_index];})));
            if(colorIndex>=0&&productColors.length===cfg.colors.length)desiredColor=productColors[colorIndex];
          }
          var available=product.variants.filter(function(v){return v.available===true&&(!desiredColor||v.options[cfg.color_index]===desiredColor);});
          var sizes=Array.from(new Set(available.map(function(v){return v.options[cfg.size_index];}))).filter(function(s){return cfg.sizes.indexOf(s)>=0;});
          var answer=estimate(cm,kg,gender,cfg.runs_small,sizes);
          if(ticket!==generation)return;
          if(answer.error){result.textContent=answer.error;return;}
          var matching=available.filter(function(v){return v.options[cfg.size_index]===answer.size;});
          var text=tr('Suggested starting size: ')+answer.size+tr('. This is a rough estimate; check the garment details and allow room for layers.');
          if(cfg.runs_small)text+=tr(' This style is listed as running small; the estimate includes one size up.');
          if(cfg.color_index!==null){
            var colorNames=Array.from(new Set(matching.map(function(v){return v.options[cfg.color_index];})));
            text+=tr(' Currently available in ')+colorNames.slice(0,6).map(function(c){return jfIsPolish&&window.JuanaThemeI18n.colors[c]?window.JuanaThemeI18n.colors[c]:c;}).join(', ')+(colorNames.length>6?tr(' and other colors'):'')+'.';
          }
          result.textContent=text;
        } catch (_) {
          if(ticket===generation)result.textContent=tr('We could not confirm current availability. Please use the product’s size selector and try again.');
        } finally {clearTimeout(timeout);button.disabled=false;button.textContent=tr('Find my starting size');}
      });
    });
  }
  window.JuanaSizeFinder={init:init,estimate:estimate};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
  document.addEventListener('shopify:section:load',init);
  var queued=false;
  new MutationObserver(function(changes){
    if(queued||!changes.some(function(c){return Array.from(c.addedNodes).some(function(n){return n.nodeType===1&&(n.matches('.jf-size-finder')||n.querySelector('.jf-size-finder'));});}))return;
    queued=true;setTimeout(function(){queued=false;init();},0);
  }).observe(document.documentElement,{childList:true,subtree:true});
})();
